<div [ngClass]="class2" class="tab relative">
  <fa-icon class="pr-2 text-2xl cursor-pointer" *ngIf="faIcon" [icon]="faIcon"></fa-icon>
  <button class="outline-none cursor-pointer font-bold">{{ tabName | titlecase }}</button>
  <div *ngIf="isTooltip" class="tooltip hidden absolute -top-8">
    <div class="bg-orange px-4 py-1 text-white rounded-full">Mới nhất</div>
    <div class="triangle-down absolute left-9"></div>
  </div>
</div>
